import React from 'react';
import { FileListData } from '@typings/ResidentTypes';
import { respectFormCompletedOptions } from './commons';
import UploadRespectFormDocument from './UploadRespectFormDocument';

interface RespectFormSectionProps {
  userId: string;
  hasRespectFormCompleted: string;
  respectFormFiles: FileListData[];
  setRespectFormFiles: React.Dispatch<React.SetStateAction<FileListData[]>>;
  updateEndOfLifeCare: (
    field: 'hasRespectFormCompleted',
    value: string
  ) => void;
}

const RespectFormSection: React.FC<RespectFormSectionProps> = ({
  userId,
  hasRespectFormCompleted,
  respectFormFiles,
  setRespectFormFiles,
  updateEndOfLifeCare,
}) => {
  const isRespectFormUploadEnabled = hasRespectFormCompleted === 'yes';

  return (
    <div className="mt-10 govuk-bp:mt-14">
      <h2 className="govuk-heading-l">ReSPECT Form</h2>

      <div className="govuk-form-group">
        <label className="govuk-label" htmlFor="respect-form-completed">
          Has a ReSPECT form been completed?
        </label>

        <select
          className="govuk-select govuk-!-width-one-half"
          id="respect-form-completed"
          name="hasRespectFormCompleted"
          value={hasRespectFormCompleted}
          onChange={e =>
            updateEndOfLifeCare('hasRespectFormCompleted', e.target.value)
          }
        >
          {respectFormCompletedOptions.map(option => (
            <option key={option.value || 'select'} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <UploadRespectFormDocument
        userId={userId}
        uploadedRespectFormFileList={respectFormFiles}
        setUploadedRespectFormFileList={setRespectFormFiles}
        isUploadEnabled={isRespectFormUploadEnabled}
      />
    </div>
  );
};

export default RespectFormSection;
